import { render } from "./TSMR.vue?vue&type=template&id=5d539b4d"
import script from "./TSMR.vue?vue&type=script&lang=js"
export * from "./TSMR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__